export const getListingImageId = image => {
  return image?.imageId?.uuid || image?.id?.uuid || null;
};

export const createImagesOrder = images => {
  return (images || [])
    .map((image, index) => {
      const id = getListingImageId(image);
      return id ? { id, position: index } : null;
    })
    .filter(Boolean);
};

export const getOrderedListingImages = listing => {
  const images = listing?.images || [];
  const imagesOrder = listing?.attributes?.publicData?.imagesOrder;

  if (!Array.isArray(imagesOrder) || imagesOrder.length === 0) {
    return images;
  }

  const orderedImages = imagesOrder
    .map(item => images.find(image => getListingImageId(image) === item?.id))
    .filter(Boolean);

  const orderedIds = new Set(orderedImages.map(getListingImageId));
  const remainingImages = images.filter(image => !orderedIds.has(getListingImageId(image)));

  return [...orderedImages, ...remainingImages];
};

export const getCoverImage = listing => {
  return getOrderedListingImages(listing)[0] || null;
};
